/*
 *  Class FooterMenu
 */
export
default class Footer {
    constructor() {
        this.footer = document.querySelector('footer');
        if (!this.footer) {
            return;
        }
        this.footerLinks = this.footer.querySelectorAll('a[href]');
    }

    init() {
        this.bindTracking();
    }

    bindTracking() {

        this.footerLinks.forEach(link => {
            this.trackLink(link, '1');
        });

    }

    trackLink(link, level) {
        level = level || '1';

        link.addEventListener('click', () => {

            const textContent = (link.textContent || link.getAttribute('title') || '').replace(/\s+/g,' ').trim();

					  const url = new URL(link.href);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event_parameter: null });
            window.dataLayer.push({
                event: 'custom_event',
                event_name: 'menu_interaction',
                event_parameter: {
                    action: 'click',
                    element_type: 'footer menu',
                    page_section: 'footer',
                    navigation_level: level, // "1"
                    click_text: textContent, // "Mobilgeräte" {page-title}
                    link_url: link.href, // "https://www.mobilezone.ch/de/mobilgeraete"
                    page_location: url.origin // "https://www.mobilezone.ch/de/mobilgeraete"
                }
            });
        });
    }
}
